import { H } from 'highlight.run';
import omit from 'lodash/omit';

const HighlighHelper = {
  identify: (user: any) => {
    H.identify &&
      H.identify(user.email, {
        id: user.id,
        name: user.name,
        //   last_organization: omit(user.last_organization), TODO - this fails due to type mismatch
      });
  },
};

H.init(process.env.HIGHLIGHT_KEY_EDITOR, {
  environment: process.env.ENVIRONMENT,
  networkRecording: {
    enabled: true,
    recordHeadersAndBody: true,
  },
});

export default HighlighHelper;
